import * as phone from "./formatPhoneNumber.js";
import * as name from "./formatName.js";
import * as email from "./formatEmail.js";
import * as address from "./formatAddress.js";
import * as currency from "./gbpStringToPence.js";
import { getInvoicePaymentStatus } from "./getInvoicePaymentStatus.ts";

export const two = {
  ...phone,
  ...name,
  ...email,
  ...address,
  ...currency,
  getInvoicePaymentStatus,
};
